import { useEffect, useState } from 'react';
function usePromise(promise, initialData, deps, immediateRequest) {
    var _a = useState(initialData), data = _a[0], setData = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), isError = _c[0], setIsError = _c[1];
    useEffect(function () {
        var didCancel = false;
        setIsError(false);
        setIsLoading(true);
        promise
            .then(function (response) {
            if (!didCancel) {
                setData(response);
            }
        })
            .catch(function () {
            if (!didCancel) {
                setIsError(true);
            }
        })
            .finally(function () {
            if (!didCancel) {
                setIsLoading(false);
            }
        });
        return function () {
            didCancel = true;
        };
    }, deps);
    if (immediateRequest) {
        return { data: data, isLoading: isLoading, isError: isError };
    }
    else {
        var request = function () { };
        return { data: data, isLoading: isLoading, isError: isError, request: request };
    }
}
export default usePromise;
//# sourceMappingURL=usePromise.js.map